interface SpacerProps {
    height?: number
    width?: number
}

export const Spacer = ({ height = 10, width = 10 }: SpacerProps) => {
    return <div style={{ height, width }} />
}
